module.exports = __webpack_public_path__ + "6b325b145802e3cec731277ad86b1198.png";